export type RoiRectMode = 'abs' | 'percent';

export interface RoiRect {
  x: number;
  y: number;
  width: number;
  height: number;
  mode: RoiRectMode;
}

function asRecord(value: unknown): Record<string, unknown> | undefined {
  return (typeof value === 'object' && value !== null && !Array.isArray(value))
    ? value as Record<string, unknown>
    : undefined;
}

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

/** '0,0,100,100' → { x, y, width, height } или undefined при невалидном тексте. */
export function parseRoiCoordinates(text: string): Omit<RoiRect, 'mode'> | undefined {
  const parts = text.split(',').map((part) => Number(part.trim()));
  if (parts.length !== 4 || !parts.every(isFiniteNumber)) return undefined;

  const [x, y, width, height] = parts;

  return {
    x, y, width, height,
  };
}

/** { x, y, width, height } → '0,0,100,100'; неполные координаты → ''. */
export function formatRoiCoordinates(value: unknown): string {
  const roi = asRecord(value);
  const numbers = [roi?.x, roi?.y, roi?.width, roi?.height];

  if (!numbers.every(isFiniteNumber)) return '';

  return numbers.join(',');
}

export function getRoiRectMode(value: unknown): RoiRectMode {
  return asRecord(value)?.mode === 'abs' ? 'abs' : 'percent';
}

/** Сохраняет прочие поля roi/droi, обновляет координаты и режим. */
export function mergeRoiRect(
  value: unknown,
  patch: Partial<RoiRect>,
): RoiRect {
  return { ...asRecord(value), ...patch } as RoiRect;
}
